import React, {useState} from 'react';
import PropTypes from "prop-types";
import IconButton from '@mui/material/IconButton';
import InputAdornment from '@mui/material/InputAdornment';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';

import Input from "@/components/form/MUIInput.jsx";

const MUIPasswordInput = React.forwardRef((props, ref) => {
    const [showPassword, setShowPassword] = useState(false);

    return (
        <Input
            {...props}
            type={showPassword ? 'text' : 'password'}
            ref={ref}
            endAdornment={
                <InputAdornment position="end">
                    <IconButton
                        aria-label="toggle password visibility"
                        onClick={() => setShowPassword(!showPassword)}
                        edge="end"
                    >
                        {showPassword ? <VisibilityOff/> : <Visibility/>}
                    </IconButton>
                </InputAdornment>
            }
        />
    );
});

MUIPasswordInput.propTypes = {
    label: PropTypes.string,
    errorMessage: PropTypes.any,
};

export default MUIPasswordInput;
